import React, { useMemo } from 'react';
import T from 'prop-types';
import { isEmpty } from 'lodash';
import { TASK_TYPES } from 'workflow/constants/newInbox';
import DetailRows from '../DetailRows/DetailRows';
import { EVENT_TYPE, EVENT_TYPEV4, getFieldsOfCustomEvent } from './EventTypeField';
import DetailRowsv4 from '../DetailRows/DetailRowsv4';

export const EventRequest = ({ detail = {}, isNewV4, isMobileView }) => {
    const { event } = detail;

    const configs = useMemo(() => {
        if (event && !isEmpty(event)) {
            if (event.eventType === EVENT_TYPE.MONITOR_VISIT.displayName) {
                return isNewV4 ? EVENT_TYPEV4.MONITOR_VISIT.fields : EVENT_TYPE.MONITOR_VISIT.fields;
            } else {
                return isNewV4 ? EVENT_TYPEV4.ICF.fields : EVENT_TYPE.ICF.fields;
            }
        } else {
            return getFieldsOfCustomEvent(detail, isNewV4);
        }
    }, [event]);

    return isNewV4 ? <DetailRowsv4 data={detail} configs={configs} taskType={TASK_TYPES.EVENT} isMobileView={isMobileView} /> : <DetailRows data={detail} configs={configs} taskType={TASK_TYPES.EVENT} />;
};

EventRequest.propTypes = {
    detail: T.object,
    isNewV4: T.bool,
    isMobileView: T.bool
};

export default EventRequest;
